/**
 * Strips all keys whose value is null or undefined from an object.
 * Useful for partial upsert/update payloads where unset fields should be omitted.
 */
export function omitNullish<T extends Record<string, unknown>>(obj: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== null && value !== undefined)
  ) as Partial<T>;
}

/**
 * Returns a new object containing only the keys whose value is not undefined.
 * Use when building flat variable bags (e.g. notification vars) from params objects
 * that have optional fields — undefined entries are treated as absent.
 */
export function pickDefined<V>(obj: Record<string, V | undefined>): Record<string, V> {
  return Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== undefined)
  ) as Record<string, V>;
}
